<div
  class="component-container text-cool-grey h-[100%] flex flex-col justify-center items-center space-y-[2.4rem]">
  <div
    class="verify-account-form-container md:w-[80%] w-full flex flex-col justify-center items-center space-y-[2.4rem] p-[4rem]">
    <app-step-progress-indicator
      [currentStep]="2"
      [totalSteps]="5"
    ></app-step-progress-indicator>
    <div
      class="heading font-poppins font-bold mb-[2.4rem] flex justify-center text-center ">
      Verify your account
    </div>
    <div
      class="message font-work-sans font-normal mb-[2.4rem] text-center"
    >
      Please enter your phone number to receive a verification code to verify
      your account
    </div>
    <form
      class="w-full"
    >
      <app-phone-number-input
        class="phone-number-input"
        [parentFormGroup]="form"
        controlName="phoneNumber"
        placeholder="Phone Number"
        label="Phone Number"
        (checkForErrors)="checkForErrorsInPhoneNumberForm($event)"
        [error]="errorMessages['phoneNumber']"
        type="small"
      ></app-phone-number-input>
      <div class="action-section w-full flex flex-col items-center">
        <app-primary-button
          class="get-otp-btn w-[70%] flex justify-center"
          (click)="getOtp()"
          [isLoading]="generateOtpLoading"
        >
          Send Verification Code
        </app-primary-button>
      </div>
    </form>
  </div>
</div>
